<template>
  <el-select
    v-model="transType"
    style="width: 100px;"
    placeholder="请选择出库单类型"
    @change="onChange">
    <el-option
      label="全部"
      :value="null">
    </el-option>
    <el-option
      v-for="item in list"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
import { TransTypeName } from '../../utils/index'
export default {
  name: 'TransTypeSelect',
  props: {
    callback: {
      type: Function
    },
    value: {
      required: true
    },
    option: {
      type: Object
    }
  },
  data() {
    return {
      list: TransTypeName
    }
  },
  computed: {
    transType: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onChange() {
      this.callback && this.callback()
    }
  }
}
</script>
